import React from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
const Nav = styled.nav`
  background: ${({ theme }) => theme.palette.colorWhite};
  & > ul {
    display: flex;
    padding: 0;
    margin: 0;
    & > li {
      list-style: none;
      & > a {
        position: relative;
        text-decoration: none;
        cursor: pointer;
        color: ${({ theme }) => theme.palette.colorDarkGray2};

        &:hover {
          color: ${({ theme }) => theme.palette.colorBlue};
        }
        &:after {
          content: '';
          position: absolute;
          width: 100%;
          bottom: 0;
          left: 0;
          height: 0;
          transition: all ease-out 150ms;
        }
        &:hover::after,
        &.active:after {
          height: 0.2rem;
          background: ${({ theme }) => theme.palette.colorBlue};
        }
        padding: 0 1rem;
        display: block;
        height: 3rem;
        line-height: 3rem;
      }
    }
  }
`

const Navigation = () => (
  <Nav>
    <ul>
      <li>
        <FormattedMessage id="patientList">
          {label => (
            <NavLink exact activeClassName="active" to="/patients">
              {label}
            </NavLink>
          )}
        </FormattedMessage>
      </li>
      <li>
        <FormattedMessage id="addPatient">
          {label => (
            <NavLink activeClassName="active" to="/patients/add">
              {label}
            </NavLink>
          )}
        </FormattedMessage>
      </li>
      <li>
        <NavLink activeClassName="active" to="/login">
          login
        </NavLink>
      </li>
    </ul>
  </Nav>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation.js